export enum DispatchedEvents {
    ReceivedParticipantBreakoutState = 'ReceivedParticipantBreakoutState',
    ReceivedCreatorBreakoutState = 'ReceivedCreatorBreakoutState',
    ReceivedBreakoutRoomStartedStatus = 'ReceivedBreakoutRoomStartedStatus'
}
